const destinations = [
  {
    title: "Dubai",
    subtitle: "Business Bay",
    url: "https://images.unsplash.com/photo-1512453979798-5ea266f8880c?crop=entropy&cs=srgb&fm=jpg&w=1200&q=85",
    span: "md:col-span-7 md:row-span-2 aspect-[16/12]",
  },
  {
    title: "Singapore",
    subtitle: "Marina Bay",
    url: "https://images.unsplash.com/photo-1565967511849-76a60a516170?crop=entropy&cs=srgb&fm=jpg&w=1200&q=85",
    span: "md:col-span-5 aspect-[16/10]",
  },
  {
    title: "London",
    subtitle: "Canary Wharf",
    url: "https://images.unsplash.com/photo-1605702012553-e954fbde66eb?crop=entropy&cs=srgb&fm=jpg&w=1200&q=85",
    span: "md:col-span-5 aspect-[16/10]",
  },
  {
    title: "Bali",
    subtitle: "Ubud & Uluwatu",
    url: "https://images.unsplash.com/photo-1537996194471-e657df975ab4?crop=entropy&cs=srgb&fm=jpg&w=1200&q=85",
    span: "md:col-span-4 aspect-[4/5]",
  },
  {
    title: "Kerala",
    subtitle: "Backwaters",
    url: "https://images.unsplash.com/photo-1590523277543-a94d2e4eb00b?crop=entropy&cs=srgb&fm=jpg&w=1200&q=85",
    span: "md:col-span-4 aspect-[4/5]",
  },
  {
    title: "Kashmir",
    subtitle: "Gulmarg & Srinagar",
    url: "https://images.unsplash.com/photo-1596895111956-bf1cf0599ce5?crop=entropy&cs=srgb&fm=jpg&w=1200&q=85",
    span: "md:col-span-4 aspect-[4/5]",
  },
];

export default function Destinations() {
  return (
    <section
      id="destinations"
      data-testid="destinations-section"
      className="relative py-24 sm:py-32 bg-white border-t border-[#4A1D96]/10"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-8 mb-14 reveal">
          <div className="max-w-2xl">
            <span className="uppercase tracking-[0.28em] text-xs text-[#F97316] font-semibold">
              Where we send you
            </span>
            <h2
              data-testid="destinations-heading"
              className="mt-4 font-serif text-4xl sm:text-5xl leading-[1.05] text-[#1B0F3A]"
            >
              Board meetings in Dubai.
              <br />
              <span className="brand-gradient italic font-medium">
                Anniversaries in Bali.
              </span>
            </h2>
          </div>
          <p className="text-[#3B2A5B]/80 max-w-sm text-base">
            Six of our most-booked routes this season. Ask us about the other
            thirty-six.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-4 md:gap-5">
          {destinations.map((d) => (
            <a
              key={d.title}
              href="#contact"
              data-testid={`destination-${d.title.toLowerCase()}`}
              className={`group relative overflow-hidden ${d.span} reveal shadow-[0_20px_50px_-25px_rgba(74,29,150,0.4)]`}
            >
              <img
                src={d.url}
                alt={d.title}
                className="absolute inset-0 w-full h-full object-cover transition-transform duration-[1200ms] ease-out group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#1B0F3A]/90 via-[#1B0F3A]/20 to-transparent" />
              <div className="absolute inset-0 border-2 border-transparent group-hover:border-[#F97316] transition-colors duration-500" />
              <div className="absolute bottom-0 left-0 right-0 p-6 sm:p-8">
                <div className="text-xs uppercase tracking-[0.22em] text-[#FFB47A] font-semibold">
                  {d.subtitle}
                </div>
                <h3 className="mt-2 font-serif text-2xl sm:text-3xl text-white">
                  {d.title}
                </h3>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
